<template>
	<div class="share-poster">
		<FixedTool />

		<img src="../assets/images/share-poster-copy.png" class="bg" ref="imgSize" @onload="imgload" style="width: 100%;" />

		<nut-button block class="share-button" id="share-btn" v-bind:style="{top:btnTop+'px'}" @click="shareActivity">分享<template v-if="this.$ajax.is_activity()">活动</template><template v-else>平台</template>给好友</nut-button>
	</div>
</template>

<script>
export default {
	name: 'share-poster',
	data() {
		return {
			btnTop: 493,
		}
	},
	methods:{
		shareActivity(){
			var activityId = this.$ajax.get_activity_id();
			this.$router.push({name:'ActivityShare',query:{activity_id:activityId}})
		},
		imgload() {
			let imgSize = this.$refs['imgSize'];

		}
	},
	created() {
		var btnTop = 493;
		var pmWidth = window.screen.width;
		this.btnTop = btnTop * (pmWidth/375);
		//document.getElementById('share-btn').style.top = btnTop + 'px;';
	},
	mounted() {
		// var shareButton = document.getElementById('share-btn');
		// shareButton.setAttribute('style', 'top: ' + btnTop + 'px;');
    window.document.title='分销达人招募计划';
    setTimeout(()=>{
      window.document.title='分销达人招募计划';
    },1500);
    setTimeout(()=>{
      window.document.title='分销达人招募计划';
    },3000);
	}
}
</script>

<style lang="less" scoped>
.bg {
    width: 100%;
}
.share-button {
	position: absolute;
    left: 10%;
    z-index: 10;
    width: 80%;
	height: 40px;
	background: linear-gradient(
		221deg,
		rgba(0, 194, 255, 1) 0%,
		rgba(60, 67, 236, 1) 100%
	);
	opacity: 1;
	border-radius: 20px;
}
</style>
